export const translations = {
  en: {
    // Header
    home: "Home",
    about: "About",
    projects: "Projects",
    contact: "Contact",
    
    // Hero
    heroTitle: "Hi, I'm Khasanov Sayfillo",
    heroSubtitle: "Full Stack Developer & CS Student",
    heroDescription: "Welcome to my portfolio! I'm a Computer Science student at Gachon University, passionate about web development and creating innovative solutions.",
    learnMore: "Learn More",
    
    // About
    aboutTitle: "About Me",
    aboutMeTitle: "Me",
    aboutMeText: "I'm Khasanov Sayfillo, a Computer Science student at Gachon University (202339764). Passionate about technology and continuous learning.",
    
    aboutSkillsTitle: "Skills",
    aboutSkillsText: "React, JavaScript, HTML/CSS, Node.js, Git, Linux, Database Management",
    
    aboutInterestsTitle: "Interests",
    aboutInterestsText: "Web Development, Cloud Computing, Open Source, Gaming (CS2)",
    
    aboutLearningTitle: "Currently Learning",
    aboutLearningText: "Advanced React patterns, TypeScript, Docker, Azure Cloud Services",
    
    // Projects
    projectsTitle: "Projects",
    viewProject: "View Project →",
    
    project1Title: "React Portfolio Website",
    project1Desc: "A modern one-page portfolio built with React. Features smooth scrolling, responsive design, and a clean dark UI.",
    
    project2Title: "CS2 Info Web Page",
    project2Desc: "Counter-Strike 2 information hub featuring game mechanics, maps, and strategies. Built with vanilla HTML/CSS/JS.",
    
    project3Title: "Linux Practice & Report",
    project3Desc: "Comprehensive documentation of Linux system administration, shell scripting, and file system concepts.",
    
    project4Title: "CampusEAT",
    project4Desc: "Web/mobile application designed for Gachon University students to discover campus dining locations and menus.",
    
    project5Title: "SmartPantry",
    project5Desc: "Inventory management system built with NestJS and SQL. Manages products, users, and orders with comprehensive tracking features.",
    
    project6Title: "Kiosk App V3",
    project6Desc: "Restaurant kiosk application built with Java OOP principles. Features menu selection, order placement, and payment calculation.",
    
    // Contact
    contactTitle: "Get In Touch",
    contactSubtitle: "Feel free to reach out!",
    
    contactEmail: "Email",
    contactGithub: "GitHub",
    contactLinkedin: "LinkedIn",
    
    nameLabel: "Your Name",
    emailLabel: "Your Email",
    messageLabel: "Your Message",
    sendButton: "Send Message",
    successMessage: "Message sent successfully!",
    
    // Footer
    footerText: "Built with React",
  },
  
  ko: {
    // Header
    home: "홈",
    about: "소개",
    projects: "프로젝트",
    contact: "연락처",
    
    // Hero
    heroTitle: "안녕하세요, 저는 Khasanov Sayfillo입니다",
    heroSubtitle: "풀스택 개발자 & 컴퓨터공학 학생",
    heroDescription: "제 포트폴리오에 오신 것을 환영합니다! 저는 가천대학교 컴퓨터공학과 학생이며, 웹 개발과 혁신적인 솔루션 개발에 열정을 가지고 있습니다.",
    learnMore: "더 알아보기",
    
    // About
    aboutTitle: "소개",
    aboutMeTitle: "나",
    aboutMeText: "저는 가천대학교 컴퓨터공학과(202339764) 학생 Khasanov Sayfillo입니다. 기술과 지속적인 학습에 열정을 가지고 있습니다.",
    
    aboutSkillsTitle: "기술",
    aboutSkillsText: "React, JavaScript, HTML/CSS, Node.js, Git, Linux, 데이터베이스 관리",
    
    aboutInterestsTitle: "관심사",
    aboutInterestsText: "웹 개발, 클라우드 컴퓨팅, 오픈소스, 게임(CS2)",
    
    aboutLearningTitle: "현재 학습 중",
    aboutLearningText: "고급 React 패턴, TypeScript, Docker, Azure 클라우드 서비스",
    
    // Projects
    projectsTitle: "프로젝트",
    viewProject: "프로젝트 보기 →",
    
    project1Title: "React 포트폴리오 웹사이트",
    project1Desc: "React로 구축된 현대적인 원페이지 포트폴리오. 부드러운 스크롤, 반응형 디자인, 깔끔한 다크 UI를 특징으로 합니다.",
    
    project2Title: "CS2 정보 웹페이지",
    project2Desc: "Counter-Strike 2 게임 메커니즘, 맵, 전략을 소개하는 정보 허브. 순수 HTML/CSS/JS로 제작되었습니다.",
    
    project3Title: "Linux 실습 및 보고서",
    project3Desc: "Linux 시스템 관리, 셸 스크립팅, 파일 시스템 개념에 대한 종합 문서.",
    
    project4Title: "CampusEAT",
    project4Desc: "가천대학교 학생들을 위한 캠퍼스 내 식당 위치와 메뉴를 보여주는 웹/모바일 애플리케이션.",
    
    project5Title: "SmartPantry",
    project5Desc: "NestJS와 SQL 기반의 재고 관리 시스템. 제품, 사용자, 주문을 종합적으로 관리하는 기능 제공.",
    
    project6Title: "Kiosk App V3",
    project6Desc: "Java OOP 원칙으로 구축된 레스토랑 키오스크 애플리케이션. 메뉴 선택, 주문 접수, 결제 계산 기능 포함.",
    
    // Contact
    contactTitle: "연락하기",
    contactSubtitle: "언제든지 연락주세요!",
    
    contactEmail: "이메일",
    contactGithub: "깃허브",
    contactLinkedin: "링크드인",
    
    nameLabel: "이름",
    emailLabel: "이메일",
    messageLabel: "메시지",
    sendButton: "메시지 보내기",
    successMessage: "메시지가 성공적으로 전송되었습니다!",
    
    // Footer
    footerText: "React로 제작",
  }
};
